'use client';

import clsx from 'clsx';
import Image from 'next/image';
import { AppLink } from '@/shared/ui/atoms';
import type { LogoProps } from './types';

const Logo = ({ src, alt, width, height, text, href = '/', className, onClick }: LogoProps) => {
    return (
        <AppLink
            href={href}
            className={clsx(className)}
            onClick={onClick}
            startIcon={
                <Image
                    src={src}
                    alt={alt}
                    width={width}
                    height={height}
                    priority
                />
            }
        >
            {text}
        </AppLink>
    );
};

export default Logo;
